import React from 'react';
import styled from 'styled-components';

const SplashContainer = styled.div`
  height: 100vh;
  width: 100%;
  background: #000000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
  
  /* Desktop PWA constraint */
  @media (min-width: 768px) {
    max-width: 414px;
    width: 414px;
    margin: 0 auto;
    box-shadow: 0 0 40px rgba(0, 0, 0, 0.8), 
                0 0 0 12px rgba(0, 0, 0, 0.5),
                0 0 0 16px #333333;
    border-radius: 24px;
    left: 50%;
    transform: translateX(-50%);
    position: relative;
    z-index: 1;
  }
`;

const LogoImage = styled.img`
  max-width: 200px;
  width: 100%;
  height: auto;
  object-fit: contain;
`;

const SplashScreen: React.FC = () => {
  return (
    <SplashContainer>
      <LogoImage 
        src="/landing-assets/mavrk_white_logo.png" 
        alt="Mavrk Logo" 
      />
    </SplashContainer>
  );
};

export default SplashScreen;

